// GENERATED file — do not edit by hand.
//
// Emitted by tests/realmauthority/bind-editor-contract.mjs from the
// digest-pinned, byte-verified core-realmauthority-editor contract
// (tests/realmauthority/pinned/ at the Spec commit in contract-pin.json).
// The browser client (src/services/realmAuthorityGroupsApi.js) builds its
// wire paths and bodies from these DECLARED operation shapes — never from
// a hand-typed endpoint string. Drift gate: run
// `npm run test:realm-editor:binding` (chained into the editor unit lane);
// it fails when this file is not byte-identical to a fresh regeneration
// from the pinned bytes.
export const EDITOR_CONTRACT = Object.freeze({
  contract: "core-realmauthority-editor",
  contractVersion: "1.2.0",
  contractDigest: "71d030548dfec7692348500a75f8e05814250934c23f8765a3e0150d90dda115",
  specCommit: "c9d4531a656ddd8dd4dd4e3a306c13ceb34014b7",
  canonicalRoutes: Object.freeze({
    getRealmAuthorityDirectory: "/api/v1/orgs/{orgId}/realm-authority/directory",
    getRealmAuthorityGroups: "/api/v1/orgs/{orgId}/realm-authority/groups",
    getRealmAuthorityLinkStatus: "/api/v1/orgs/{orgId}/realm-authority/link",
    getRealmAuthorityMembershipDoorOutcomes: "/api/v1/orgs/{orgId}/realm-authority/groups/{groupSid}/membership-outcomes",
    submitGroupMembershipChanges: "/api/v1/orgs/{orgId}/realm-authority/groups/{groupSid}/membership",
    submitPersonRename: "/api/v1/orgs/{orgId}/realm-authority/people/{objectSid}/rename",
  }),
  operations: Object.freeze({
    submitPersonRename: Object.freeze({
      method: "POST",
      route: "/api/v1/orgs/{orgId}/realm-authority/people/{objectSid}/rename",
      request: "PersonRenameRequest",
      response: "PersonRenameResponse",
    }),
    submitGroupMembershipChanges: Object.freeze({
      method: "POST",
      route: "/api/v1/orgs/{orgId}/realm-authority/groups/{groupSid}/membership",
      request: "MembershipChangeRequest",
      response: "MembershipChangeBatchResponse",
    }),
    getRealmAuthorityMembershipDoorOutcomes: Object.freeze({
      method: "GET",
      route: "/api/v1/orgs/{orgId}/realm-authority/groups/{groupSid}/membership-outcomes",
      request: null,
      response: "RealmAuthorityMembershipDoorOutcomesResponse",
    }),
  }),
});

export default EDITOR_CONTRACT;
